export enum DeactivateTypeEnum {
    Company = 1,
    Department = 2,
    SubDepartment = 3,
}
